module.exports = __webpack_public_path__ + "img/sumary_battery_charge.938ca0f0.svg";